<template>
    <div class="streetcontainer" :style="{backgroundImage:'url(' + this.ossPath + 'streetbg.png)', backgroundRepeat:'no-repeat'}">
      
      <!-- 职业地图事件横幅 -->
      <transition name="career-fade">
        <div v-if="careerBanner" class="career-banner">
          <span class="career-ico">✦</span>{{careerBanner}}
        </div>
      </transition>
      <!-- 限时增益栏（buff_v1） -->
      <div class="street-buff-wrap">
        <buff-bar></buff-bar>
      </div>
      <!-- 场景内容：滑动动画包裹层（移动时位移过渡，不重建组件） -->
      <div class="street-anim" ref="streetAnim">
      <div class="main">
        <div class="placediv">
          <div class="placetitle">
            【{{city.cityname }}】{{cityMap.placename }}
          </div>
          <div class="placedesc">
            {{cityMap.placedesc }}
          </div>
        </div>
        <!-- npc区域 -->
        <div class="npcdiv">
          <npclist></npclist>
        </div>
        <div class="grounddiv">
          <div class="groundtitle" title="点击地上的道具可以将它收入囊中哦！">
            地上的道具
          </div>
          <!-- 街道地面 -->
          <streetGround
            v-bind:cityMap="cityMap"
            v-bind:itemList="itemList"></streetGround>
        </div>
      </div>

      <div class="sidebox">
        <div class="userdiv">
          <div class="usertitle">
            玩家列表
          </div>
          <div class="userlist">
            <!--
              两行制：昵称 + 称号。
              账号从列表移除——这个格子只有 181px 宽，19 位雪花账号一挂上去就把整行撑爆，
              而列表要回答的是「谁在这、什么身份」，「账号是什么」在情报卡里本来就有。
              点整条打开情报卡（称号徽标自己的点击已在组件内 stop，弹的是称号详情）。
            -->
            <div class="useritem" v-for="user in userPositions" v-bind:key="user.id" :id="'user_'+user.id"
                 :title="'查看 ' + (user.nickName || user.userName) + ' 的情报'"
                 @click="openPlayerCard(user)">
              <span class="uname">{{user.nickName}}</span>
              <TitleBadge
                v-if="titleMap[user.id]"
                class="utitle"
                :title="titleMap[user.id].title"
                :short-title="titleMap[user.id].shortTitle"
                :tier="titleMap[user.id].tier"
                :type-name="titleMap[user.id].typeName"
                :evaluate-date="titleMap[user.id].evaluateDate"
                variant="two-line"
                ground="light"
                :max-chars="8" />
            </div>
          </div>
        </div>
        <!-- <select id="userlist" name="userlist"  class="selectStyle" multiple="multiple">
          <option v-for="user in userPositions" v-bind:key="user.id" :value="user.id">{{user.nickname}}({{user.username}})</option>
        </select> -->
        <div class="event">
          <div class="eventtitle">
            特殊事件
          </div>
          <div class="eventitem">
            <div v-show="Number(cityMap.id) === Number(fantasyUserBO.homePoint)" id="gohome">
              <a @click="toHome"><font>回家</font></a>
            </div>
            <div v-if="null != fantasyMapShopBO" id="store" class="store"
              @click="toggleShopOpts('shopOpts_' + fantasyMapShopBO.shopId);">
              <a><font>{{fantasyMapShopBO.shopName}}</font></a>
              <div :id="'shopOpts_' + fantasyMapShopBO.shopId"
                v-show="shopOpts == 'showshopOpts_' + fantasyMapShopBO.shopId" class="shopOptsDiv"
                @mouseover="showDiv('shopOpts_' + fantasyMapShopBO.shopId);"
                @mouseout="hiddenDiv('shopOpts_' + fantasyMapShopBO.shopId);">
                <div class="opts">
                    <a v-if="fantasyMapShopBO.shopStatus == 1 || fantasyMapShopBO.shopStatus == 3" @click.stop="showShopItems();">买东西</a>
                    <a v-if="fantasyMapShopBO.shopStatus == 2 || fantasyMapShopBO.shopStatus == 3" @click.stop="showSellableItems();">卖东西</a>
                </div>
              </div>
            </div>
            
            <!-- 特殊事件：后端 fantasy_special_event 配置驱动，不再硬编码mapId -->
            <template v-for="event in specialEvents">
              <div v-if="event.eventKey === 'tradeCenter'" :key="event.id" class="store"
                @click="toggleShopOpts('shopOpts_' + event.id);">
                <a><font>{{event.eventName}}</font></a>
                <div :id="'shopOpts_' + event.id"
                  v-show="shopOpts == 'showshopOpts_' + event.id" class="shopOptsDiv"
                  @mouseover="showDiv('shopOpts_' + event.id);"
                  @mouseout="hiddenDiv('shopOpts_' + event.id);">
                  <div class="opts">
                      <a @click.stop="toTradeCenter();">淘宝</a>
                      <a @click.stop="toTradeSell();">出货</a>
                  </div>
                </div>
              </div>
              <div v-else :key="event.id">
                <a @click="dispatchSpecialEvent(event)"><font>{{event.eventName}}</font></a>
              </div>
            </template>
          </div>
        </div>
        <!-- 水面渔获：同地图其他玩家钓到的鱼，限时围观（轮询 /item/fishing/waterShowcase） -->
        <div class="watershowcase" v-if="waterShowcases.length > 0">
          <div class="watershowcase-title">🌊 水面渔获</div>
          <div class="watershowcase-list">
            <div v-for="ws in waterShowcases" :key="ws.showcaseId" class="watershowcase-item"
                 :title="ws.nickName + ' 钓到了 ' + ws.fishTypeName">
              <span class="ws-time">剩{{ws.remainSec}}s</span>
              <span class="ws-by">{{ws.nickName}}</span>
              <span v-if="ws.rareLevel >= 1" class="ws-rare" :style="{color: ws.rareColor, borderColor: ws.rareColor}">{{ws.rareLabel}}</span>
              <span class="ws-fish" :style="{color: ws.rareColor}">{{ws.fishTypeName}}</span>
            </div>
          </div>
        </div>
        <div class="quickmove">
          <div class="quickmovetitle">
            快速移动
          </div>
          <div class="quickmoves">
            <!-- 回家入口在左栏与特殊事件区已有，此处不重复展示 -->
          </div>
        </div>
      </div>
      </div>

      <!-- 移动遮罩：移动期间覆盖场景防连点 -->
      <div class="move-mask" v-if="moving"></div>

      <!-- 右下角常用功能快捷条（地图/背包/任务/存盘） -->
      <street-quick-bar></street-quick-bar>

      <!-- 商店道具列表 延迟加载shopItemList组件，在点击时才进行加载 -->
      <div v-if="showShopItemList">
        <shopItemList
          v-on:shop_item_dialog_close="shop_item_dialog_close"
          v-bind:shopItemsVisible="shopItemsVisible"
          v-bind:fantasyUserBO="fantasyUserBO"
          v-bind:fantasyMapShopBO="fantasyMapShopBO"></shopItemList>
      </div>

      <!-- 背包可出售道具 延迟加载shopItemList组件，在点击时才进行加载 -->
      <div v-if="showSellableItemList">
        <sellableItemList
          v-on:sellable_items_dialog_close="sellable_items_dialog_close"
          v-bind:fantasyMapShopBO="fantasyMapShopBO"
          v-bind:showSellableItemList="showSellableItemList"
          v-bind:sellableItemsVisible="sellableItemsVisible"></sellableItemList>
      </div>

      <!-- 称号列表 延迟加载titleTypeList组件，在点击时才进行加载 -->
      <div v-if="showTitleTypeList">
        <titleTypeList
          v-on:title_type_list_dialog_close="title_type_list_dialog_close"
          v-bind:titleTypeListVisible="titleTypeListVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></titleTypeList>
      </div>

      <!-- 学校学习 延迟加载titleTypeList组件，在点击时才进行加载 -->
      <div v-if="showStudyDiv">
        <study
          v-on:study_dialog_close="study_dialog_close"
          v-bind:studyDivVisible="studyDivVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></study>
      </div>

      <!-- 银行 延迟加载titleTypeList组件，在点击时才进行加载 -->
      <div v-if="showBankDiv">
        <bank
          v-on:bank_dialog_close="bank_dialog_close"
          v-bind:bankDivVisible="bankDivVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></bank>
      </div>

      <!-- 交易中心列表 延迟加载组件，在点击时才进行加载 -->
      <div v-if="showTradeCenterDiv">
        <tradeCenter
          v-on:trade_center_dialog_close="trade_center_dialog_close"
          v-bind:tradeCenterDivVisible="tradeCenterDivVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></tradeCenter>
      </div>
      <!-- 出货页面 -->
      <div v-if="showTradeSellDiv">
        <tradeSell
          v-on:trade_sell_dialog_close="trade_sell_dialog_close"
          v-bind:tradeSellDivVisible="tradeSellDivVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></tradeSell>
      </div>
      <!-- 道具合成 -->
      <div v-if="showComposeItemDiv">
      <composeItem
        v-on:compose_item_dialog_close="compose_item_dialog_close"
        v-bind:composeItemTableVisible="composeItemTableVisible"
        v-bind:composeFormulaBOList="composeFormulaBOList"></composeItem>
      </div>

      <!-- 寻物列表 延迟加载titleTypeList组件，在点击时才进行加载 -->
      <div v-if="showTreasureDiv">
        <treasureList
          v-on:treasure_list_dialog_close="treasure_list_dialog_close"
          v-bind:treasureListVisible="treasureListVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></treasureList>
      </div>

      <!-- 美容中心 -->
      <div v-if="showBeautyCenterDiv">
        <beautyCenter
          v-on:beauty_center_dialog_close="beauty_center_dialog_close"
          v-bind:beautyCenterVisible="beautyCenterVisible"
          v-bind:fantasyUserBO="fantasyUserBO"></beautyCenter>
      </div>

      <!-- 钓鱼面板 -->
      <div v-if="showFishingDiv">
        <fishingPanel
          v-on:fishing_dialog_close="fishing_dialog_close"
          v-bind:fishingVisible="fishingVisible"
          v-bind:fishingSpotId="fishingSpotId"
          v-bind:fantasyUserBO="fantasyUserBO"></fishingPanel>
      </div>

      <!-- 挖矿面板 -->
      <div v-if="showMiningDiv">
        <miningPanel
          v-on:mining_dialog_close="mining_dialog_close"
          v-bind:miningVisible="miningVisible"
          v-bind:mineSpotId="mineSpotId"
          v-bind:fantasyUserBO="fantasyUserBO"></miningPanel>
      </div>

      <!-- 共享厨房面板 -->
      <div v-if="showKitchenDiv">
        <kitchenPanel
          v-on:kitchen_dialog_close="kitchen_dialog_close"
          v-bind:kitchenVisible="kitchenVisible"
          v-bind:facilityKey="kitchenFacilityKey"></kitchenPanel>
      </div>

      <!-- 工坊面板（制造地点化：下单→计时→回坊领取） -->
      <div v-if="showWorkshopDiv">
        <workshopPanel
          v-on:workshop_dialog_close="workshop_dialog_close"
          v-bind:workshopVisible="workshopVisible"
          v-bind:facilityKey="workshopFacilityKey"></workshopPanel>
      </div>

      <!-- 果园堆肥点面板（perish_v1.2） -->
      <div v-if="showCompostDiv">
        <compostPanel
          v-on:compost_dialog_close="compost_dialog_close"
          v-bind:compostVisible="compostVisible"></compostPanel>
      </div>

      <!-- 仓库小游戏面板（分拣货物/清扫货仓） -->
      <div v-if="showWarehouseGameDiv">
        <warehouseGame
          v-on:warehouse_game_dialog_close="warehouse_game_dialog_close"
          v-bind:warehouseGameVisible="warehouseGameVisible"
          v-bind:warehouseGameType="warehouseGameType"></warehouseGame>
      </div>

      <!-- 新手指引（街道场景） -->
      <guideOverlay
        v-if="guideVisible"
        v-bind:steps="guideSteps"
        v-on:finish="onGuideFinish('street')"></guideOverlay>

      <!-- 车站乘车面板（cross-city coach）：本站班次 → 沿途报站 → 到站落地 -->
      <div v-if="showCoachDiv">
        <coachPanel
          v-on:coach_dialog_close="coach_dialog_close"
          v-bind:coachVisible="coachVisible"
          v-bind:routeKey="coachRouteKey"></coachPanel>
      </div>

      <!-- 王都动态地图弹窗（南大门电子地图等特殊事件入口） -->
      <wangdu-dialog ref="wangduDialog"></wangdu-dialog>

      <!-- 玩家情报卡：点玩家列表任一条打开（只显示公开信息 + 私聊/加好友） -->
      <playerCard ref="playerCard" :self-id="fantasyUserBO.id"></playerCard>
    </div>
</template>

<script>
import eventBus from '../../store/eventBus'
import {postRequest, getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import {mapState} from 'vuex'
import npclist from './npclist'
import streetGround from './streetGround'
import TitleBadge from '../common/TitleBadge'
import playerCard from '../common/PlayerCard'
import sellableItemList from './sellableItemList'
import titleTypeList from './titleTypeList'
import study from './study'
import bank from './bank'
import tradeCenter from './tradeCenter'
import tradeSell from './tradeSell'
import composeItem from './composeItem'
import treasureList from './treasureList'
import beautyCenter from './beautyCenter'
import fishingPanel from './fishingPanel'
import miningPanel from './miningPanel'
import kitchenPanel from './kitchenPanel'
import workshopPanel from './workshopPanel'
import compostPanel from './compostPanel'
import warehouseGame from './warehouseGame'
import coachPanel from './coachPanel'
import BuffBar from '../common/BuffBar'
import guideOverlay from '../common/GuideOverlay'
import wangduDialog from '../maps/wangduDialog'
import streetQuickBar from './streetQuickBar'
import {buildStreetGuideSteps} from '../../utils/guideSteps'
export default {
  components:{
    npclist,
    streetGround,
    TitleBadge,
    playerCard,
    shopItemList: () => import("./shopItemList"),
    sellableItemList,
    titleTypeList,
    study,
    bank,
    tradeCenter,
    tradeSell,
    composeItem,
    treasureList,
    beautyCenter,
    BuffBar,
    fishingPanel,
    miningPanel,
    kitchenPanel,
    workshopPanel,
    compostPanel,
    warehouseGame,
    coachPanel,
    guideOverlay,
    wangduDialog,
    streetQuickBar
  },
  data() {
    return {
      items: {},
      shopOpts: "",
      shopItemsVisible: false,
      showShopItemList: false,
      sellableItemsVisible: false,
      showSellableItemList: false,
      titleTypeListVisible: false,
      showTitleTypeList: false,
      showStudyDiv: false,
      studyDivVisible: false,
      showBankDiv: false,
      bankDivVisible: false,
      showTradeCenterDiv: false,
      tradeCenterDivVisible: false,
      showTradeSellDiv: false,
      tradeSellDivVisible: false,
      showComposeItemDiv: false,
      composeItemTableVisible: false,
      composeFormulaBOList: [],
      treasureListVisible: false,
      showTreasureDiv: false,
      beautyCenterVisible: false,
      showBeautyCenterDiv: false,
      fishingVisible: false,
      showFishingDiv: false,
      fishingSpotId: null,
      miningVisible: false,
      showMiningDiv: false,
      kitchenVisible: false,
      showKitchenDiv: false,
      kitchenFacilityKey: 'shared_kitchen',
      workshopVisible: false,
      showWorkshopDiv: false,
      workshopFacilityKey: '',
      compostVisible: false,
      showCompostDiv: false,
      mineSpotId: null,
      warehouseGameVisible: false,
      showWarehouseGameDiv: false,
      warehouseGameType: 'sort',
      coachVisible: false,
      showCoachDiv: false,
      coachRouteKey: '',
      waterShowcases: [],        // 同图水面渔获围观列表（{showcaseId,nickName,fishTypeName,rareLevel,rareLabel,rareColor,remainSec}）
      waterShowcaseTimer: null,  // 围观轮询定时器
      waterShowcaseTick: null,   // 本地倒计时定时器
      careerBanner: '',          // 职业地图事件横幅（顶部非阻断提示）
      careerBannerTimer: null,
      guideVisible: false,
      guideSteps: [],
      // userId → 称号（同屏玩家）。同屏人数个位数，整表一次取回即可
      titleMap: {},
    };
  },
  computed: {
    ...mapState('street', ['cityMap', 'city', 'itemList', 'userPositions', 'fantasyMapShopBO', 'specialEvents', 'moving', 'moveDirection']),
    ...mapState('user', ['fantasyUserBO'])
  },
  mounted: function () {
    eventBus.$on('careerEvent', this.showCareerBanner);
    this.$store.dispatch('street/initStreet');
    this.startGuide();
  },
  beforeDestroy: function () {
    eventBus.$off('careerEvent', this.showCareerBanner);
    this.stopWaterShowcase();
  },
  watch: {
    // 同屏名单变化（有人进出地图）时刷新称号
    userPositions: {
      handler(list) {
        this.loadUserTitles(list);
      }
    },
    // 移动滑动动画：moving=true 旧画面滑出；全部数据就绪 moving=false 新画面滑入
    'cityMap.id': function () {
      // 切到新地图：清空旧图围观，重新拉取当前水域渔获
      this.waterShowcases = [];
      this.startWaterShowcase();
    },
    // 到站引导：首次进入幻之都时提示一次。
    // 这座城刚建好，大半节点还没有 NPC / 商店 / 事件，不提前说明的话
    // 玩家第一反应会是「传送坏了」或「地图空了」，而不是「还在建设中」。
    'city.cityid': function (cid) {
      if (String(cid) !== '2') return;
      try {
        if (localStorage.getItem('fantasy_city2_guide')) return;
        localStorage.setItem('fantasy_city2_guide', '1');
      } catch (e) {
        // 隐私模式下 localStorage 不可用：宁可不记，也别挡着提示
      }
      Message({
        message: '欢迎来到幻之都六芒星城。这座城仍在建设中，部分街区暂无 NPC 与设施；' +
                 '沿19号大街向东可进城，回王都可在西门车站乘车。',
        type: 'success',
        duration: 8000,
        showClose: true
      });
    },
    moving(val) {
      if (val) {
        this._moveStart = Date.now();
        this.setStreetAnim('slide-out-' + (this.moveDirection || ''));
      } else {
        const dir = this.moveDirection;
        if (!dir) { this.setStreetAnim(''); return; }
        // 保证滑出动画至少播完（后端可能返回很快），再滑入新场景
        const elapsed = Date.now() - (this._moveStart || 0);
        const delay = Math.max(0, 300 - elapsed);
        setTimeout(() => this.slideInStreet(dir), delay);
      }
    }
  },
  methods: {
    /**
     * 拉取同屏玩家的称号（一次批量请求）。
     *
     * 玩家列表数据本身来自 Redis 里的 FantasyUserBO 快照，那份快照里没有称号；
     * 改成前端按 userId 批量补一次，好处是不用动缓存写入链路
     * （评定了但别人看不见，正是这条链路最容易出的问题）。
     */
    loadUserTitles(list) {
      const ids = (list || [])
        .map(u => (u && u.id != null ? String(u.id) : ''))
        .filter(Boolean);
      if (ids.length === 0) {
        this.titleMap = {};
        return;
      }
      getRequest('/user/title/getUserTitles', { userIds: ids.join(',') }).then(resp => {
        if (resp.status == 200 && resp.data && 200 == resp.data.status) {
          this.titleMap = resp.data.data || {};
        }
      }, () => {});
    },
    // 点玩家列表任一条：打开情报卡。称号直接用列表已批量取回的那份，不再单独请求
    openPlayerCard(user) {
      if (!user) return;
      this.$refs.playerCard.open(user, this.titleMap[user.id]);
    },
    // 新手指引：查后端完成记录，未做过街道场景指引才弹出；拉全量待办拼任务链动态文案
    startGuide() {
      getRequest('/user/user/guide/list').then(resp => {
        if (resp.status == 200 && resp.data.status == 200) {
          const finished = resp.data.data || [];
          if (finished.indexOf('street') !== -1) return;
          // getTaskList 不受当前节点有无 NPC 限制（getTaskTodoList 在无 NPC 节点不返回待办）
          getRequest('/task/task/getTaskList').then(resp2 => {
            let todo = [];
            if (resp2.status == 200 && resp2.data.status == 200) {
              todo = (resp2.data.data && resp2.data.data.fantasyTaskTodoBOList) || [];
            }
            // 等 600ms：避开路由切换动画的 transform，等布局稳定
            setTimeout(() => {
              try {
                this.guideSteps = buildStreetGuideSteps(todo);
              } catch (e) {
                // 步骤构建失败也要兜底弹指引（临时可见化诊断：内容里带错误信息）
                this.guideSteps = [{ title: '欢迎来到王都！', content: '指引加载出错：' + (e && e.message), selector: '' }];
              }
              this.guideVisible = true;
            }, 600);
          }).catch(() => {
            setTimeout(() => {
              try {
                this.guideSteps = buildStreetGuideSteps([]);
              } catch (e) {
                this.guideSteps = [{ title: '欢迎来到王都！', content: '指引加载出错：' + (e && e.message), selector: '' }];
              }
              this.guideVisible = true;
            }, 600);
          });
        }
      }).catch(() => {});
    },
    // 指引关闭/完成后落库，之后不再显示
    onGuideFinish(guideKey) {
      this.guideVisible = false;
      postRequest('/user/user/guide/finish?guideKey=' + guideKey).catch(() => {});
    },
    sellable_items_dialog_close(){
      this.showSellableItemList = false;
      this.sellableItemsVisible = false;
    },
    //背包可售道具
    showSellableItems: function(){
      this.showSellableItemList = true;
      this.sellableItemsVisible = true;
    },
    showDiv: function(shopOpts) {
        this.shopOpts = "show" + shopOpts;
    },
    // 移动端友好的切换显示
    toggleShopOpts: function(shopOpts) {
        const key = "show" + shopOpts;
        if (this.shopOpts === key) {
            this.shopOpts = "hidden" + shopOpts;
        } else {
            this.shopOpts = key;
        }
    },
    //当鼠标移动到目标div的子元素上时，会触发子元素的mouseoverDiv方法，设置inDiv = true，这样延迟后的判断条件就不成立，从而继续显示了。
    hiddenDiv: function(shopOpts) {
        this.shopOpts = "hidden" + shopOpts;
    },
    shop_item_dialog_close(value){
      this.showShopItemList = value;
      this.shopItemsVisible = value;
    },
    getFullTitleTree() {
      // 称号评定处，查询全部称号信息
      this.showTitleTypeList = true;
      this.titleTypeListVisible = true;
    },
    title_type_list_dialog_close(){
      this.showTitleTypeList = false;
      this.titleTypeListVisible = false;
    },
    toHome: function() {
      this.$router.replace({path: '/main/home.html'});
    },
    // 统一管理滑动动画 class（避免 Vue patch 覆盖手动 classList 操作）
    setStreetAnim(cls) {
      const el = this.$refs.streetAnim;
      if (!el) return;
      const anims = ['slide-out-east', 'slide-out-west', 'slide-out-north', 'slide-out-south',
        'slide-out-northwest', 'slide-out-northeast', 'slide-out-southwest', 'slide-out-southeast',
        'slide-in-east', 'slide-in-west', 'slide-in-north', 'slide-in-south',
        'slide-in-northwest', 'slide-in-northeast', 'slide-in-southwest', 'slide-in-southeast'];
      el.classList.remove.apply(el.classList, anims);
      if (cls) el.classList.add(cls);
    },
    // 新场景滑入：先无过渡跳到滑入起点，下一帧过渡回原位
    slideInStreet(dir) {
      this.$nextTick(() => {
        const el = this.$refs.streetAnim;
        if (!el) return;
        // 移动端：新场景从顶部开始
        this.$el.scrollTop = 0;
        el.style.transition = 'none';
        el.classList.remove('slide-out-' + dir);
        el.classList.add('slide-in-' + dir);
        void el.offsetHeight;
        el.style.transition = '';
        requestAnimationFrame(() => {
          el.classList.remove('slide-in-' + dir);
        });
      });
    },
    showShopItems: function() {
      this.showShopItemList = true;
      this.shopItemsVisible = true;
    },
    toSpa: function() {
      const _this = this;
      this.$confirm('请注意，洗浴中心每天首次免费，第二次和第三次各需消耗一张澡票（做满当日任务必得，寻物雷达挖宝也有几率掉落），帮助您除去疲劳，焕然一新。', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(function () {
          postRequest('/user/user/relieveFatigue', {
          }).then(resp=> {
              if (resp.status == 200) {
                  const respData = resp.data;
                  if (200 == respData.status) {
                      Message.success(respData.message);
                      _this.$store.dispatch('user/fetchUserDetail');
                  } else {
					          Message.error(respData.message);
                  }
              } else {
                  Message.error('用户非法⊙﹏⊙∥!');
              }
          }, resp=> {
              Message.error('用户非法⊙﹏⊙∥!');
          });
      });
    },
    plantItem: function(value) {
      const _this = this;
      postRequest('/item/specialEvent/plantItem', {
          itemType: value
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  let msg = respData.message;
                  if (respData.data.addExp != null) {
                    msg += "<br>经验值增加：" + respData.data.addExp;
                  }
                  if (respData.data.addMoney != null) {
                    msg += "<br>资金增加：" + respData.data.addMoney;
                  }
                  if (respData.data.getItem != null) {
                    msg += "<br>" + respData.data.getItem;
                  }
                  if (respData.data.getTaskItem != null) {
                    msg += "<br>" + respData.data.getTaskItem;
                  }
                  Message({
                    dangerouslyUseHTMLString: true,
                    message: msg,
                    type: 'success'
                  });
                  this.$store.dispatch('user/fetchUserDetail');
              } else {
                  Message({
                    dangerouslyUseHTMLString: true,
                    message: respData.message,
                    type: 'error'
                  });
              }
          } else {
              Message.error('用户非法⊙﹏⊙∥!');
          }
      }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    cuttingTree: function() {
      const _this = this;
      postRequest('/item/specialEvent/cuttingTree', {
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  Message.success(respData.message);
                  this.$store.dispatch('user/fetchUserDetail');
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('用户非法⊙﹏⊙∥!');
          }
      }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    harvestSeed: function() {
      const _this = this;
      postRequest('/item/specialEvent/harvestSeed', {
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  Message.success(respData.message);
                  this.$store.dispatch('user/fetchUserDetail');
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('用户非法⊙﹏⊙∥!');
          }
      }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    mysteryButton: function() {
      const _this = this;
      postRequest('/item/specialEvent/mysteryButton', {
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  Message.success(respData.message);
                  this.$store.dispatch('user/fetchUserDetail');
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('用户非法⊙﹏⊙∥!');
          }
      }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    showComposeItems: function(value) {
        const _this = this;
        _this.composeItemTableVisible = true;
        _this.showComposeItemDiv = true;
        postRequest('/item/specialEvent/showComposeItems', {
            type: value
        }).then(resp=> {
            if (resp.status == 200) {
                //成功
                const respData = resp.data;
                if (200 == respData.status) {
                  _this.composeFormulaBOList = respData.data.composeFormulaBOList;
                } else {
                    Message.error(respData.message);
                }
            } else {
                //失败
                Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    compose_item_dialog_close() {
      this.composeItemTableVisible = false;
      this.showComposeItemDiv = false;
    },
    toStudy() {
      // 学习
      this.showStudyDiv = true;
      this.studyDivVisible = true;
    },
    study_dialog_close(){
      this.showStudyDiv = false;
      this.studyDivVisible = false;
    },
    toBank() {
      // 银行
      this.showBankDiv = true;
      this.bankDivVisible = true;
    },
    bank_dialog_close(){
      this.showBankDiv = false;
      this.bankDivVisible = false;
    },
    toTradeCenter() {
      // 交易中心
      this.showTradeCenterDiv = true;
      this.tradeCenterDivVisible = true;
    },
    trade_center_dialog_close(){
      this.showTradeCenterDiv = false;
      this.tradeCenterDivVisible = false;
    },
    toTradeSell() {
      // 交易中心
      this.showTradeSellDiv = true;
      this.tradeSellDivVisible = true;
    },
    trade_sell_dialog_close(){
      this.showTradeSellDiv = false;
      this.tradeSellDivVisible = false;
    },
    toTreasureList() {
      // 寻物列表
      this.showTreasureDiv = true;
      this.treasureListVisible = true;
    },
    treasure_list_dialog_close(){
      this.showTreasureDiv = false;
      this.treasureListVisible = false;
    },
    // 美容中心
    toBeautyCenter() {
      this.showBeautyCenterDiv = true;
      this.beautyCenterVisible = true;
    },
    beauty_center_dialog_close(){
      this.showBeautyCenterDiv = false;
      this.beautyCenterVisible = false;
    },
    // 特殊事件分发（数据驱动：eventKey/eventParam 由后端 fantasy_special_event 配置）
    dispatchSpecialEvent(event) {
      const key = event.eventKey;
      const param = event.eventParam;
      switch(key) {
        case 'plant':
          this.plantItem(param);
          break;
        case 'cuttingTree':
          this.cuttingTree();
          break;
        case 'harvestSeed':
          this.harvestSeed();
          break;
        case 'mysteryButton':
          this.mysteryButton();
          break;
        case 'compose':
          this.showComposeItems(param);
          break;
        case 'treasure':
          this.toTreasureList();
          break;
        case 'study':
          this.toStudy();
          break;
        case 'bank':
          this.toBank();
          break;
        case 'title':
          this.getFullTitleTree();
          break;
        case 'spa':
          this.toSpa();
          break;
        case 'beautyCenter':
          this.toBeautyCenter();
          break;
        case 'fishing':
          this.toFishing(param);
          break;
        case 'mining':
          this.toMining(param);
          break;
        case 'kitchen':
          this.toKitchen(param);
          break;
        case 'workshop':
          // 工坊（制造地点化）：event_param = facilityKey，前端直接透传
          this.toWorkshop(param);
          break;
        case 'compost':
          this.toCompost();
          break;
        case 'coach':
          // 车站乘车：event_param = route_key，前端只透传，具体有哪些车次由后端线路表决定
          this.toCoach(param);
          break;
        case 'digBait':
          this.digBait();
          break;
        case 'warehouseSort':
          this.toWarehouseGame('sort');
          break;
        case 'warehouseClean':
          this.toWarehouseGame('clean');
          break;
        case 'wangduMap':
          // 南大门电子地图：弹出王都动态地图（复用顶栏同款弹窗组件）
          this.$refs.wangduDialog.open();
          break;
        default:
          break;
      }
    },
    // 共享厨房面板
    toKitchen(facilityKey) {
      if (facilityKey) {
        this.kitchenFacilityKey = facilityKey;
      }
      this.kitchenVisible = true;
      this.showKitchenDiv = true;
    },
    kitchen_dialog_close() {
      this.kitchenVisible = false;
      this.showKitchenDiv = false;
    },
    // 工坊面板（制造地点化）
    toWorkshop(facilityKey) {
      if (!facilityKey) {
        return;
      }
      this.workshopFacilityKey = facilityKey;
      this.workshopVisible = true;
      this.showWorkshopDiv = true;
    },
    workshop_dialog_close() {
      this.workshopVisible = false;
      this.showWorkshopDiv = false;
    },
    // 车站乘车（跨城班线）：面板自己拉班次、自己播报站过场，这里只负责开关
    toCoach(routeKey) {
      this.coachRouteKey = routeKey || '';
      this.coachVisible = true;
      this.showCoachDiv = true;
    },
    coach_dialog_close() {
      this.coachVisible = false;
      this.showCoachDiv = false;
    },
    // 果园堆肥点面板（perish_v1.2）
    toCompost() {
      this.compostVisible = true;
      this.showCompostDiv = true;
    },
    compost_dialog_close() {
      this.compostVisible = false;
      this.showCompostDiv = false;
    },
    // 钓鱼点挖鱼饵（需背包携带木铲，消耗体力/疲劳；挖鱼饵不磨损木铲，磨损只发生在挖宝）
    digBait() {
      const _this = this;
      this.$confirm('用【木铲】在河岸边挖些鱼饵吗？将消耗 10 点体力和 1 点疲劳。', '提示', {
          confirmButtonText: '挖掘',
          cancelButtonText: '取消',
          type: 'info'
      }).then(function () {
          postRequest('/item/specialEvent/digBait', {}).then(resp=> {
              if (resp.status == 200) {
                  const respData = resp.data;
                  if (200 == respData.status) {
                      Message.success(respData.message);
                      _this.$store.dispatch('user/fetchUserDetail');
                  } else {
                      Message.error(respData.message);
                  }
              } else {
                  Message.error('用户非法⊙﹏⊙∥!');
              }
          }, resp=> {
              Message.error('用户非法⊙﹏⊙∥!');
          });
      }, function () {});
    },
    // 仓库小游戏面板（分拣货物/清扫货仓）
    toWarehouseGame(gameType) {
      this.warehouseGameType = gameType;
      this.showWarehouseGameDiv = true;
      this.warehouseGameVisible = true;
    },
    warehouse_game_dialog_close(){
      this.showWarehouseGameDiv = false;
      this.warehouseGameVisible = false;
    },
    // 钓鱼面板
    toFishing(spotId) {
      this.fishingSpotId = spotId;
      this.showFishingDiv = true;
      this.fishingVisible = true;
    },
    fishing_dialog_close(){
      this.showFishingDiv = false;
      this.fishingVisible = false;
    },
    // 挖矿面板
    toMining(spotId) {
      this.mineSpotId = spotId;
      this.showMiningDiv = true;
      this.miningVisible = true;
    },
    mining_dialog_close(){
      this.showMiningDiv = false;
      this.miningVisible = false;
    },
    // ==================== 水面渔获围观 ====================
    // 轮询当前地图水面展示（同图其他玩家钓到的鱼）
    loadWaterShowcase() {
      const mapId = this.cityMap && this.cityMap.id ? this.cityMap.id : null;
      if (!mapId) return;
      getRequest('/item/fishing/waterShowcase', {
        mapId: mapId
      }).then(resp => {
        if (resp.status == 200) {
          const rd = resp.data;
          if (200 == rd.status) {
            // 以服务端为准整表刷新（后端已清理过期/裁剪上限、按最新排序）
            this.waterShowcases = (rd.data || []).map(item => Object.assign({}, item));
          }
        }
      }, () => { /* 围观查询失败静默，下轮重试 */ });
    },
    // 当前地图是否配置了钓鱼点（fishing 特殊事件）
    // 只有存在钓鱼点的地图，水面上才可能出现别人钓到的鱼；其余地图轮询必然拿到空列表
    hasFishingSpot() {
      return Array.isArray(this.specialEvents)
        && this.specialEvents.some(event => event && event.eventKey === 'fishing');
    },
    // 启动围观：无钓鱼点的地图直接不启动（fishing 事件现网只配在 2 张地图上，
    // 原先 96 张地图全都每 8 秒轮询一次，绝大多数请求注定拿到空结果）
    startWaterShowcase() {
      this.stopWaterShowcase();
      if (!this.hasFishingSpot()) {
        this.waterShowcases = [];
        return;
      }
      this.loadWaterShowcase();
      this.waterShowcaseTimer = setInterval(() => {
        if (document.visibilityState !== 'hidden') {
          this.loadWaterShowcase();
        }
      }, 8000);
      this.waterShowcaseTick = setInterval(() => {
        const next = [];
        for (const item of this.waterShowcases) {
          const remain = (item.remainSec != null ? item.remainSec : 0) - 1;
          if (remain > 0) {
            next.push(Object.assign({}, item, {remainSec: remain}));
          }
        }
        this.waterShowcases = next;
      }, 1000);
    },
    stopWaterShowcase() {
      if (this.waterShowcaseTimer) {
        clearInterval(this.waterShowcaseTimer);
        this.waterShowcaseTimer = null;
      }
      if (this.waterShowcaseTick) {
        clearInterval(this.waterShowcaseTick);
        this.waterShowcaseTick = null;
      }
    },
    // 职业地图事件横幅（顶部非阻断，4 秒后收起）
    showCareerBanner(careerEvent) {
      if (!careerEvent || !careerEvent.msg) {
        return;
      }
      if (this.careerBannerTimer) {
        clearTimeout(this.careerBannerTimer);
      }
      this.careerBanner = careerEvent.msg;
      this.careerBannerTimer = setTimeout(() => {
        this.careerBanner = '';
        this.careerBannerTimer = null;
      }, 4500);
    },
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
  color: blue;
}
a:hover {text-decoration:underline;color:#FF0000}  
.streetcontainer {
	width:735px;
	height:475px;
	position: relative;
  margin: 0;
  padding: 0;
}
/* ========== 移动滑动动画 ========== */
.street-anim {
  transition: transform 0.3s ease;
  /* 不加 will-change:transform —— 它会创建包含块+层叠上下文，把场内 fixed 弹窗/遮罩
     （npcTalk 交谈层等）困在本元素内，压不过音乐盒(300)/快捷条(350)等全局悬浮件；
     transform 过渡本身即合成层动画，去掉后平滑度无损（2026-10-02） */
  overflow: hidden;
}
/* 滑出：旧画面按相机移动反方向离场
   （用 vh/vw 视口单位而非百分比：百分比基于元素自身尺寸，内容/视口差距大时会露边，
     视口单位保证元素完全移出视口） */
.street-anim.slide-out-east { transform: translateX(-120vw); }
.street-anim.slide-out-west { transform: translateX(120vw); }
.street-anim.slide-out-north { transform: translateY(120vh); }
.street-anim.slide-out-south { transform: translateY(-120vh); }
.street-anim.slide-out-northwest { transform: translate(120vw, 120vh); }
.street-anim.slide-out-northeast { transform: translate(-120vw, 120vh); }
.street-anim.slide-out-southwest { transform: translate(120vw, -120vh); }
.street-anim.slide-out-southeast { transform: translate(-120vw, -120vh); }
/* 滑入起点：新画面从移动方向进场（视口外） */
.street-anim.slide-in-east { transform: translateX(120vw); }
.street-anim.slide-in-west { transform: translateX(-120vw); }
.street-anim.slide-in-north { transform: translateY(-120vh); }
.street-anim.slide-in-south { transform: translateY(120vh); }
.street-anim.slide-in-northwest { transform: translate(-120vw, -120vh); }
.street-anim.slide-in-northeast { transform: translate(120vw, -120vh); }
.street-anim.slide-in-southwest { transform: translate(-120vw, 120vh); }
.street-anim.slide-in-southeast { transform: translate(120vw, 120vh); }
/* 移动遮罩：全屏盖住视口（场景滑出后不露出页面空白），防连点 + 视觉过渡
   z-index 需高于 APlayer(300) 等固定元素，低于 Element UI 弹窗/消息(2000+) */
.move-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 400;
}
/* 中左 开始 */
.main {
	width:500px;
  height:475px;
  float: left;
	margin-left: 10px;
	border-top:3px solid #143755;
	border-right:3px solid #143755;
}
.placediv {
  height: 35%;
}
.placetitle {
	height:20px;
	background-color:#72b653;
	padding:3px 5px;
	color:#ff0000;
	font-size:16px;
	font-weight:bold;
}
.placedesc {
	padding:5px;
	font-size:16px;
	line-height:21px;
	text-indent:2em;
}
.npcdiv {
  height: 21%;
}
.grounddiv {
  height: 30%;
}
.groundtitle {
	border-top:3px solid #143755;
	padding:3px 5px;
	background-color:#af865f;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px; 
}
/* 中左 结束 */
/* 中右 开始 */
.sidebox {
	border-top:3px solid #143755;
	width:210px;
  height:445px;
	float:left;
}
.userdiv .usertitle {
	width:90%;
	padding:3px 5px;
	background-color:#0080ff;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px; 
	float:right;
	text-align:center;
}
.userlist {
	background-color:#fff;
	width:90%;
	padding:3px 4px;
	/* 100px 只够单行 5 人；两行制每条约 34px，加到 160px 才装得回 5 人 */
	height:160px;
	text-align:left;
	float:right;
  border: 1px solid #0080ff;
  margin-bottom: 5px; 
  overflow:auto;
}

/* 玩家列表条目：昵称在上，称号在下；整条可点开情报卡 */
.useritem {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 3px 4px;
	line-height: 16px;
	border-bottom: 1px dashed #eef3fa;
	cursor: pointer;
}
.useritem:hover {
	background: #eaf3ff;
}
.useritem:last-child {
	border-bottom: none;
}
.uname {
	font-size: 12px;
	font-weight: bold;
	color: #333;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.event {
	width:100%;
	border-top:3px solid #143755;
	float:right;
}
.eventtitle {
	width:90%;
	padding:3px 5px;
	background-color:#0080ff;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px; 
	float:right;
	text-align:center;
}
.eventitem {
	width:90%;
	height:100px;
	text-align:center;
	padding:3px 5px;
	letter-spacing:5px; 
	float:right;
}
/* 水面渔获围观区 */
.watershowcase {
	width:100%;
	border-top:3px solid #143755;
	float:right;
}
.watershowcase-title {
	width:90%;
	padding:3px 5px;
	background-color:#0080ff;
	font-size:14px;
	font-weight:bold;
	color:#fff;
	float:right;
	text-align:center;
}
.watershowcase-list {
	width:90%;
	max-height:96px;
	overflow:auto;
	float:right;
	background:rgba(255,255,255,0.95);
	border:1px solid #0080ff;
	border-top:none;
	padding:2px 4px;
}
.watershowcase-item {
	font-size:12px;
	line-height:18px;
	padding:1px 2px;
	border-bottom:1px dashed #ccc;
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
	letter-spacing:0;
}
.watershowcase-item .ws-time {
	float:right;
	color:#999;
	font-size:11px;
	letter-spacing:0;
}
.watershowcase-item .ws-by {
	color:#666;
	letter-spacing:0;
}
.watershowcase-item .ws-rare {
	display:inline-block;
	margin:0 4px;
	padding:0 4px;
	border-radius:7px;
	font-size:10px;
	line-height:14px;
	border:1px solid;
	background:#fff;
	letter-spacing:0;
}
.watershowcase-item .ws-fish {
	font-weight:bold;
	font-size:13px;
	letter-spacing:0;
}

.store {
    height:30px;
    position:relative;
    margin:5px;

}
.store .opts {
    position:absolute;
    display: none;
    background-color: #aaa;
    z-index: 10;
    width: 80px;
    border:1px solid #f00;
}
.store .opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
.store .opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
.store .opts {
    display:block;
    position:absolute;
    top:20px;
    left:80px;
}

.quickmove{
	width:100%;
	float:right;
	border-top:3px solid #143755;
}
.quickmovetitle{
	width:90%;
	padding:3px 5px;
	background-color:#0080ff;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px; 
	float:right;
	text-align:center;
}
.quickmoves {
	width:90%;
	height:150px;
	text-align:center;
	padding:10px 0;
	float:right;
}
/* 中右 结束 */
/* 中底 开始 */
/* 中底 结束 */
/* 中主 结束 */

/* 移动端适配 */
@media (max-width: 768px) {
  /* 移动端禁用 will-change：避免其创建包含块，使弹窗/遮罩（fixed）被限制在 street-anim 内
     （否则 el-dialog 遮罩只盖街道区域，盖不住底部栏/顶部 header） */
  .street-anim {
    will-change: auto;
  }
  .streetcontainer {
    width: 100vw;
    max-width: 100vw;
    height: calc(100vh - var(--mobile-header-h) - var(--mobile-footer-h));
    overflow-y: auto;
    overflow-x: hidden;
    /* 移动端隐藏滚动条：触摸滚动无需可见指示，避免移动动画期间滚动条碍眼/占位抖动 */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .streetcontainer::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
  .main {
    width: 100%;
    float: none;
    margin: 0;
    height: auto !important;
    border-right: none;
    box-sizing: border-box;
  }
  /* ===== 地点区域紧凑 ===== */
  .placediv {
    height: auto !important;
    padding: 0 4px;
  }
  .placetitle {
    height: auto !important;
    font-size: 14px;
    padding: 1px 4px;
  }
  .placedesc {
    font-size: 13px;
    padding: 2px 4px;
    line-height: 18px;
    text-indent: 1em;
  }
  .npcdiv {
    height: auto !important;
    min-height: 30px;
  }
  .grounddiv {
    height: auto !important;
  }
  .groundtitle {
    font-size: 14px;
    padding: 2px 5px;
  }
  /* ===== 右边栏：卡片式横向布局 ===== */
  .sidebox {
    width: 100%;
    float: none;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 2px 4px;
    border-top: 1px solid #143755;
    box-sizing: border-box;
  }
  /* 玩家列表：裁剪溢出（含滚动） */
  .userdiv {
    flex: 1 1 48%;
    min-width: 0;
    border: 1px solid #0080ff;
    border-radius: 3px;
    overflow: hidden;
    margin: 0;
    box-sizing: border-box;
  }
  /* 特殊事件：不裁剪，允许下拉菜单溢出显示 */
  .event {
    flex: 1 1 48%;
    min-width: 0;
    border: 1px solid #0080ff;
    border-radius: 3px;
    overflow: visible;
    margin: 0;
    box-sizing: border-box;
    position: relative;
  }
  /* 快速移动独立一行 */
  .quickmove {
    flex: 1 1 100%;
    border: 1px solid #0080ff;
    border-radius: 3px;
    overflow: hidden;
    margin: 0;
    box-sizing: border-box;
  }
  /* 卡片标题：单行不换行 */
  .userdiv .usertitle,
  .eventtitle,
  .quickmovetitle {
    width: 100%;
    float: none;
    padding: 2px 4px;
    font-size: 13px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    background: #0080ff;
    color: #fff;
  }
  /* 卡片内容 */
  .userlist {
    width: 100%;
    height: 50px;
    float: none;
    padding: 2px 4px;
    margin: 0;
    font-size: 12px;
    border: none;
    overflow-y: auto;
  }
  /*
    移动端只有 50px 高（桌面 160px），两条 34px 只能露出 1.5 个人 ⇒ 必须退回单行。
    单行形态 = 印章 + 昵称：印章只占 1 个字宽，是这里唯一可行的类别压缩手段。
  */
  .useritem {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding: 1px 6px;
    border-bottom: none;
  }
  .useritem ::v-deep .title-badge {
    display: inline-flex;
    margin-top: 0;
    margin-left: 3px;
  }
  .useritem ::v-deep .tb-text {
    display: none;
  }
  .eventitem {
    width: 100%;
    height: auto;
    min-height: 50px;
    float: none;
    padding: 2px 4px;
    font-size: 12px;
    letter-spacing: 0;
    display: block;
  }
  .eventitem div {
    display: block;
    margin: 1px 0;
  }
  .quickmoves {
    width: 100%;
    height: auto;
    min-height: 20px;
    float: none;
    padding: 2px 4px;
    font-size: 12px;
  }
  /* 交易中心下拉菜单：左对齐避免溢出 */
  .store .opts {
    left: 0;
  }
}
/* 职业地图事件横幅 */
/* 限时增益栏（buff_v1）：悬于街道顶部右侧，不挤占场景布局 */
.street-buff-wrap {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 20;
}

.career-banner {
  position: fixed; top: 8px; left: 50%; transform: translateX(-50%);
  z-index: 3000; max-width: 90%; padding: 8px 18px;
  background: linear-gradient(90deg, #fff7e6, #fffbe6); border: 1px solid #f3d19e;
  border-radius: 20px; box-shadow: 0 2px 10px rgba(0,0,0,.15);
  color: #8a6d3b; font-size: 14px; text-align: center;
}
.career-ico { color: #e6a23c; margin-right: 6px; }
.career-fade-enter-active, .career-fade-leave-active { transition: opacity .4s, transform .4s; }
.career-fade-enter, .career-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(-12px); }
</style>